import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { EnvironmentConfig } from "@evento-ng/libs";

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://5b27e8698730e0315028bca882ff6911@o4509168864395264.ingest.de.sentry.io/4509345468710992",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

EnvironmentConfig.init({
  apiRoot: environment.apiRoot,
  authRoot: environment.authRoot,
  title: environment.title,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
